webpackJsonp([35783957827783],{

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * object.pick <https://github.com/jonschlinkert/object.pick>
	 *
	 * Copyright (c) 2014-2015 Jon Schlinkert, contributors.
	 * Licensed under the MIT License
	 */
	
	'use strict';
	
	var isObject = __webpack_require__(54);
	
	module.exports = function pick(obj, keys) {
	  if (!isObject(obj) && typeof obj !== 'function') {
	    return {};
	  }
	
	  var res = {};
	  if (typeof keys === 'string') {
	    if (keys in obj) {
	      res[keys] = obj[keys];
	    }
	    return res;
	  }
	
	  var len = keys.length;
	  var idx = -1;
	
	  while (++idx < len) {
	    var key = keys[idx];
	    if (key in obj) {
	      res[key] = obj[key];
	    }
	  }
	  return res;
	};


/***/ }),

/***/ 54:
/***/ (function(module, exports) {

	/*!
	 * isobject <https://github.com/jonschlinkert/isobject>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	module.exports = function isObject(val) {
	  return val != null && typeof val === 'object' && Array.isArray(val) === false;
	};


/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * Clamp.js 0.7.0
	 * Based on: https://github.com/xavi160/Clamp.js/commit/e313818da231b8dd8fd603dd9c9a61a9d725c22f
	 * Mixins:
	 * - https://github.com/josephschmitt/Clamp.js/pull/50
	 * - https://github.com/josephschmitt/Clamp.js/pull/49
	 *
	 * Copyright 2011-2013, Joseph Schmitt http://joe.sh
	 * Released under the WTFPL license
	 * http://sam.zoy.org/wtfpl/
	 */
	
	(function(root, factory) {
	  if (true) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node, CommonJS-like
	    module.exports = factory();
	  } else {
	    // Browser globals
	    root.$clamp = factory();
	  }
	}(this, function() {
	  /**
	   * Clamps a text node.
	   * @param {HTMLElement} element. Element containing the text node to clamp.
	   * @param {Object} options. Options to pass to the clamper.
	   */
	  function clamp(element, options) {
	    options = options || {};
	
	    var self = this,
	      win = window,
	      opt = {
	        clamp: options.clamp || 2,
	        useNativeClamp: typeof(options.useNativeClamp) != 'undefined' ? options.useNativeClamp : true,
	        splitOnChars: options.splitOnChars || ['.', '-', '–', '—', ' '], //Split on sentences (periods), hypens, en-dashes, em-dashes, and words (spaces).
	        animate: options.animate || false,
	        truncationChar: options.truncationChar || '…',
	        truncationHTML: options.truncationHTML
	      },
	
	      sty = element.style,
	      originalText = element.innerHTML,
	
	      supportsNativeClamp = typeof(element.style.webkitLineClamp) != 'undefined',
	      clampValue = opt.clamp,
	      isCSSValue = clampValue.indexOf && (clampValue.indexOf('px') > -1 || clampValue.indexOf('em') > -1),
	      truncationHTMLContainer;
	
	    if (opt.truncationHTML) {
	      truncationHTMLContainer = document.createElement('span');
	      truncationHTMLContainer.innerHTML = opt.truncationHTML;
	    }
	
	
	    // UTILITY FUNCTIONS __________________________________________________________
	
	    /**
	     * Return the current style for an element.
	     * @param {HTMLElement} elem The element to compute.
	     * @param {string} prop The style property.
	     * @returns {number}
	     */
	    function computeStyle(elem, prop) {
	      if (!win.getComputedStyle) {
	        win.getComputedStyle = function(el, pseudo) {
	          this.el = el;
	          this.getPropertyValue = function(prop) {
	            var re = /(\-([a-z]){1})/g;
	            if (prop == 'float') prop = 'styleFloat';
	            if (re.test(prop)) {
	              prop = prop.replace(re, function() {
	                return arguments[2].toUpperCase();
	              });
	            }
	            return el.currentStyle && el.currentStyle[prop] ? el.currentStyle[prop] : null;
	          };
	          return this;
	        };
	      }
	
	      return win.getComputedStyle(elem, null).getPropertyValue(prop);
	    }
	
	    /**
	     * Returns the maximum number of lines of text that should be rendered based
	     * on the current height of the element and the line-height of the text.
	     */
	    function getMaxLines(height) {
	      var availHeight = height || (element.parentNode.clientHeight-element.offsetTop),
	        lineHeight = getLineHeight(element);
	
	      return Math.max(Math.floor(availHeight / lineHeight), 0);
	    }
	
	    /**
	     * Returns the maximum height a given element should have based on the line-
	     * height of the text and the given clamp value.
	     */
	    function getMaxHeight(clmp) {
	      var lineHeight = getLineHeight(element);
	      return lineHeight * clmp;
	    }
	
	    /**
	     * Returns the line-height of an element as an integer.
	     */
	    function getLineHeight(elem) {
	      var lh = computeStyle(elem, 'line-height');
	      if (lh == 'normal') {
	        // Normal line heights vary from browser to browser. The spec recommends
	        // a value between 1.0 and 1.2 of the font size. Using 1.1 to split the diff.
	        lh = parseInt(computeStyle(elem, 'font-size'), 10) * 1.2;
	      }
	      return parseInt(lh, 10);
	    }
	
	
	    // MEAT AND POTATOES (MMMM, POTATOES...) ______________________________________
	    var splitOnChars = opt.splitOnChars.slice(0),
	      splitChar = splitOnChars[0],
	      chunks,
	      lastChunk;
	
	    /**
	     * Gets an element's last child. That may be another node or a node's contents.
	     */
	    function getLastChild(elem) {
	      if (!elem.lastChild) {
	        return;
	      }
	      //Current element has children, need to go deeper and get last child as a text node
	      if (elem.lastChild.children && elem.lastChild.children.length > 0) {
	        return getLastChild(Array.prototype.slice.call(elem.children).pop());
	      }
	      //Handle scenario where the last child is white-space node
	      else if (!elem.lastChild || !elem.lastChild.nodeValue || elem.lastChild.nodeValue === '' || elem.lastChild.nodeValue == opt.truncationChar) {
	        var sibling = elem.lastChild;
	        do {
	          if (!sibling) {
	            return;
	          }
	          //TEXT_NODE
	          if (sibling.nodeType === 3 && ['', opt.truncationChar].indexOf(sibling.nodeValue) === -1) {
	            return sibling;
	          }
	          if (sibling.lastChild) {
	            var lastChild = getLastChild(sibling);
	            if (lastChild) {
	              return lastChild;
	            }
	          }
	          //Current sibling is pretty useless
	          sibling.parentNode.removeChild(sibling);
	        } while (sibling = sibling.previousSibling);
	      }
	      //This is the last child we want, return it
	      else {
	        return elem.lastChild;
	      }
	    }
	
	    /**
	     * Removes one character at a time from the text until its width or
	     * height is beneath the passed-in max param.
	     */
	    function truncate(target, maxHeight) {
	      if (!target || !maxHeight) {
	        return;
	      }
	
	      /**
	       * Resets global variables.
	       */
	      function reset() {
	        splitOnChars = opt.splitOnChars.slice(0);
	        splitChar = splitOnChars[0];
	        chunks = null;
	        lastChunk = null;
	      }
	
	      var nodeValue = target.nodeValue.replace(opt.truncationChar, '');
	
	      //Grab the next chunks
	      if (!chunks) {
	        //If there are more characters to try, grab the next one
	        if (splitOnChars.length > 0) {
	          splitChar = splitOnChars.shift();
	        }
	        //No characters to chunk by. Go character-by-character
	        else {
	          splitChar = '';
	        }
	
	        chunks = nodeValue.split(splitChar);
	      }
	
	      //If there are chunks left to remove, remove the last one and see if
	      // the nodeValue fits.
	      if (chunks.length > 1) {
	        // console.log('chunks', chunks);
	        lastChunk = chunks.pop();
	        // console.log('lastChunk', lastChunk);
	        applyEllipsis(target, chunks.join(splitChar));
	      }
	      //No more chunks can be removed using this character
	      else {
	        chunks = null;
	      }
	
	      //Insert the custom HTML before the truncation character
	      if (truncationHTMLContainer) {
	        target.nodeValue = target.nodeValue.replace(opt.truncationChar, '');
	        element.innerHTML = target.nodeValue + ' ' + truncationHTMLContainer.innerHTML + opt.truncationChar;
	      }
	
	      //Search produced valid chunks
	      if (chunks) {
	        //It fits
	        if (element.clientHeight <= maxHeight) {
	          //There's still more characters to try splitting on, not quite done yet
	          if (splitOnChars.length >= 0 && splitChar !== '') {
	            applyEllipsis(target, chunks.join(splitChar) + splitChar + lastChunk);
	            chunks = null;
	          }
	          //Finished!
	          else {
	            return element.innerHTML;
	          }
	        }
	      }
	      //No valid chunks produced
	      else {
	        //No valid chunks even when splitting by letter, time to move
	        //on to the next node
	        if (splitChar === '') {
	          applyEllipsis(target, '');
	          target = getLastChild(element);
	
	          reset();
	        }
	      }
	
	      //If you get here it means still too big, let's keep truncating
	      if (opt.animate) {
	        setTimeout(function() {
	          truncate(target, maxHeight);
	        }, opt.animate === true ? 10 : opt.animate);
	      } else {
	        return truncate(target, maxHeight);
	      }
	    }
	
	    function applyEllipsis(elem, str) {
	      elem.nodeValue = str + opt.truncationChar;
	    }
	
	
	    // CONSTRUCTOR ________________________________________________________________
	
	    if (clampValue == 'auto') {
	      clampValue = getMaxLines();
	    } else if (isCSSValue) {
	      clampValue = getMaxLines(parseInt(clampValue, 10));
	    }
	
	    var clampedText;
	    if (supportsNativeClamp && opt.useNativeClamp) {
	      sty.overflow = 'hidden';
	      sty.textOverflow = 'ellipsis';
	      sty.webkitBoxOrient = 'vertical';
	      sty.display = '-webkit-box';
	      sty.webkitLineClamp = clampValue;
	
	      if (isCSSValue) {
	        sty.height = opt.clamp + 'px';
	      }
	    } else {
	      var height = getMaxHeight(clampValue);
	      if (height < element.clientHeight) {
	        clampedText = truncate(getLastChild(element), height);
	      }
	    }
	
	    return {
	      'original': originalText,
	      'clamped': clampedText
	    };
	  }
	
	  return clamp;
	}));


/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var clamp = __webpack_require__(60);
	var pick = __webpack_require__(53);
	var PropTypes = __webpack_require__(3);
	var ReactDOM = __webpack_require__(55);
	
	/**
	 * multuline text-overflow: ellipsis
	 */
	function Dotdotdot() {
	  if(!(this instanceof Dotdotdot)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	  this.update = this.update.bind(this);
	  this.getContainerRef = function (container) {
	    this.container = container;
	  }.bind(this);
	}
	
	Dotdotdot.prototype = Object.create(React.Component.prototype);
	Dotdotdot.prototype.componentDidMount = function() {
	  window.addEventListener('resize', this.update, false);
	  // NOTE: It's possible, not all fonts are loaded on window.load
	  window.addEventListener('load', this.update, false);
	  this.dotdotdot(ReactDOM.findDOMNode(this.container));
	};
	Dotdotdot.prototype.componentWillUnmount = function() {
	  window.removeEventListener('resize', this.update, false);
	  window.removeEventListener('load', this.update, false);
	};
	Dotdotdot.prototype.componentDidUpdate = function() {
	  this.dotdotdot(ReactDOM.findDOMNode(this.container));
	};
	
	Dotdotdot.prototype.dotdotdot = function(container) {
	  if (this.props.clamp) {
	    if (container.length) {
	      throw new Error('Please provide exacly one child to dotdotdot');
	    }
	    clamp(container, pick(this.props, [
	      'animate',
	      'clamp',
	      'splitOnChars',
	      'truncationChar',
	      'truncationHTML',
	      'useNativeClamp'
	    ]));
	  };
	};
	Dotdotdot.prototype.update = function() {
	    this.forceUpdate();
	};
	
	Dotdotdot.prototype.render = function() {
	  return React.createElement(
	    this.props.tagName,
	    {
	      ref: this.getContainerRef,
	      className: this.props.className
	    },
	    this.props.children
	  );
	};
	
	// Statics:
	Dotdotdot.propTypes = {
	  children: PropTypes.node,
	  clamp: PropTypes.oneOfType([
	    PropTypes.string,
	    PropTypes.number,
	    PropTypes.bool
	  ]).isRequired,
	  truncationChar: PropTypes.string,
	  useNativeClamp: PropTypes.bool,
	  className: PropTypes.string,
	  tagName: PropTypes.string
	};
	
	Dotdotdot.defaultProps = {
	  truncationChar: '\u2026',
	  useNativeClamp: true,
	  tagName: 'div'
	};
	
	module.exports = Dotdotdot;


/***/ }),

/***/ 116:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(116);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Collaborator = function (_React$Component) {
	  _inherits(Collaborator, _React$Component);
	
	  function Collaborator() {
	    _classCallCheck(this, Collaborator);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Collaborator.prototype.render = function render() {
	
	    return _react2.default.createElement(
	      'div',
	      { className: "collaborator-container col-xs-6 col-sm-4 col-md-4 col-lg-3 col-xl-3" },
	      _react2.default.createElement(
	        'div',
	        { className: 'collaborator' },
	        _react2.default.createElement(
	          'a',
	          { href: this.props.url, target: '_blank' },
	          _react2.default.createElement('img', { src: this.props.logo, alt: this.props.name })
	        )
	      )
	    );
	  };
	
	  return Collaborator;
	}(_react2.default.Component);
	
	Collaborator.propTypes = {
	  name: _propTypes2.default.string.isRequired,
	  logo: _propTypes2.default.string.isRequired,
	  sponsor: _propTypes2.default.bool.isRequired,
	  url: _propTypes2.default.string.isRequired
	};
	Collaborator.defaultProps = {
	  name: "Georgia Tech",
	  logo: "",
	  sponsor: false,
	  url: "#"
	};
	exports.default = Collaborator;
	module.exports = exports['default'];

/***/ }),

/***/ 334:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDotdotdot = __webpack_require__(44);
	
	var _reactDotdotdot2 = _interopRequireDefault(_reactDotdotdot);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(334);
	
	var _placeholder = __webpack_require__(65);
	
	var _placeholder2 = _interopRequireDefault(_placeholder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewsPreview = function (_React$Component) {
	  _inherits(NewsPreview, _React$Component);
	
	  function NewsPreview() {
	    _classCallCheck(this, NewsPreview);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  NewsPreview.prototype.render = function render() {
	
	    var classNm = "";
	    this.props.first ? classNm = "col-xs-12 col-sm-12 col-md-12 col-lg-offset-1 col-lg-5 col-xl-5" : classNm = "col-xs-12 col-sm-12 col-md-12 col-lg-5 col-xl-5";
	
	    return _react2.default.createElement(
	      'div',
	      { className: "news-preview-container " + classNm },
	      _react2.default.createElement(
	        'a',
	        { href: this.props.link },
	        _react2.default.createElement(
	          'div',
	          { className: "news-preview" },
	          _react2.default.createElement(
	            'div',
	            { className: "news-preview-image col-xs-6 col-lg-4" },
	            _react2.default.createElement('img', { src: this.props.image })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: "news-preview-content col-xs-6 col-lg-8" },
	            _react2.default.createElement(
	              'h4',
	              null,
	              this.props.title
	            ),
	            _react2.default.createElement(
	              _reactDotdotdot2.default,
	              { clamp: 2 },
	              _react2.default.createElement(
	                'p',
	                null,
	                this.props.description
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return NewsPreview;
	}(_react2.default.Component);
	
	NewsPreview.propTypes = {
	  image: _propTypes2.default.string,
	  title: _propTypes2.default.string.isRequired,
	  description: _propTypes2.default.string,
	  first: _propTypes2.default.bool,
	  link: _propTypes2.default.string.isRequired
	};
	NewsPreview.defaultProps = {
	  image: _placeholder2.default,
	  title: "Hello World",
	  description: "A sample description",
	  first: false
	};
	exports.default = NewsPreview;
	module.exports = exports['default'];

/***/ }),

/***/ 117:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDotdotdot = __webpack_require__(44);
	
	var _reactDotdotdot2 = _interopRequireDefault(_reactDotdotdot);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Publication = function (_React$Component) {
	  _inherits(Publication, _React$Component);
	
	  function Publication() {
	    _classCallCheck(this, Publication);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Publication.prototype.render = function render() {
	
	    return _react2.default.createElement(
	      'div',
	      { className: "publication-container col-xs-12 col-sm-12 col-md-12 col-lg-offset-1 col-lg-10 col-xl-10" },
	      _react2.default.createElement(
	        'a',
	        { href: this.props.link },
	        _react2.default.createElement(
	          'div',
	          { className: "publication" },
	          _react2.default.createElement(
	            'div',
	            { className: "title" },
	            _react2.default.createElement(
	              'h4',
	              null,
	              this.props.title
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              this.props.year
	            )
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'journal' },
	            this.props.journal,
	            '\n'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'authors' },
	            this.props.authors
	          ),
	          _react2.default.createElement(
	            _reactDotdotdot2.default,
	            { clamp: 2 },
	            _react2.default.createElement(
	              'p',
	              { className: 'abstract' },
	              this.props.abstract
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Publication;
	}(_react2.default.Component);
	
	Publication.propTypes = {
	  title: _propTypes2.default.string.isRequired,
	  authors: _propTypes2.default.string.isRequired,
	  journal: _propTypes2.default.string.isRequired,
	  year: _propTypes2.default.string.isRequired,
	  abstract: _propTypes2.default.string.isRequired,
	  link: _propTypes2.default.string,
	  linkText: _propTypes2.default.string
	};
	Publication.defaultProps = {
	  title: "Hello World",
	  year: "2016",
	  authors: "G. Yushin",
	  abstract: "The abstract of the paper goes here"
	};
	exports.default = Publication;
	module.exports = exports['default'];

/***/ }),

/***/ 118:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 88:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(118);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _placeholder = __webpack_require__(65);
	
	var _placeholder2 = _interopRequireDefault(_placeholder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Research = function (_React$Component) {
	  _inherits(Research, _React$Component);
	
	  function Research() {
	    _classCallCheck(this, Research);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Research.prototype.render = function render() {
	
	    var classNm = "";
	    this.props.first ? classNm = "col-xs-6 col-sm-6 col-md-6 col-lg-offset-1 col-lg-3dot3 col-xl-3dot3" : classNm = "col-xs-6 col-sm-6 col-md-6 col-lg-3dot3 col-xl-3dot3";
	    return _react2.default.createElement(
	      'div',
	      { className: "research-container " + classNm },
	      _react2.default.createElement(
	        'a',
	        { href: this.props.link },
	        _react2.default.createElement(
	          'div',
	          { className: "research-blurb", style: { backgroundImage: "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 100%), url(" + this.props.image + ")" } },
	          _react2.default.createElement('div', { className: "push-down" }),
	          _react2.default.createElement(
	            'h4',
	            null,
	            this.props.title
	          )
	        )
	      )
	    );
	  };
	
	  return Research;
	}(_react2.default.Component);
	
	Research.propTypes = {
	  image: _propTypes2.default.string,
	  title: _propTypes2.default.string.isRequired,
	  subtitle: _propTypes2.default.string,
	  link: _propTypes2.default.string.isRequired,
	  first: _propTypes2.default.bool
	};
	Research.defaultProps = {
	  image: _placeholder2.default,
	  title: "Hello World",
	  subtitle: "",
	  link: "",
	  first: false
	};
	exports.default = Research;
	module.exports = exports['default'];

/***/ }),

/***/ 336:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(336);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _arrow = __webpack_require__(507);
	
	var _arrow2 = _interopRequireDefault(_arrow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SeeMore = function (_React$Component) {
	  _inherits(SeeMore, _React$Component);
	
	  function SeeMore() {
	    _classCallCheck(this, SeeMore);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  SeeMore.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'row one-margin-top' },
	      _react2.default.createElement(
	        'div',
	        { className: "col-xs-12 col-sm-12 col-md-12 col-lg-offset-1 col-lg-10 col-xl-10 see-more" },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: this.props.link },
	          this.props.content
	        ),
	        _react2.default.createElement('img', { src: _arrow2.default, alt: 'arrow pointing right' })
	      )
	    );
	  };
	
	  return SeeMore;
	}(_react2.default.Component);
	
	SeeMore.propTypes = {
	  link: _propTypes2.default.string.isRequired,
	  content: _propTypes2.default.string.isRequired
	};
	SeeMore.defaultProps = {
	  link: "/",
	  content: "See More"
	};
	exports.default = SeeMore;
	module.exports = exports['default'];

/***/ }),

/***/ 507:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAxMyAyMSIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KPHRpdGxlPiYjMjM5OyYjMTMyOyYjMTMzOzwvdGl0bGU+CjxkZXNjPkNyZWF0ZWQgdXNpbmcgRmlnbWE8L2Rlc2M+CjxnIGlkPSJDYW52YXMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01MzIgLTM1NzIpIj4KPGcgaWQ9IiYjMjM5OyYjMTMyOyYjMTMzOyI+Cjx1c2UgeGxpbms6aHJlZj0iI3BhdGgwX2ZpbGwiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDUzMi4zOTQgMzU3Mi40KSIgZmlsbD0iIzJGODBFRCIvPgo8L2c+CjwvZz4KPGRlZnM+CjxwYXRoIGlkPSJwYXRoMF9maWxsIiBkPSJNIDExLjY5MiAxMC4wMjQ2QyAxMS42OTIgOS44NjM4NCAxMS42MTE2IDkuNjgzMDQgMTEuNDkxMSA5LjU2MjVMIDIuMTI5NDYgMC4yMDA4OTFDIDIuMDA4OTMgMC4wODAzNTU4IDEuODI4MTMgMCAxLjY2NzQxIDBDIDEuNTA2NyAwIDEuMzI1ODkgMC4wODAzNTU4IDEuMjA1MzYgMC4yMDA4OTFMIDAuMjAwODkyIDEuMjA1MzZDIDAuMDgwMzU2NyAxLjMyNTg5IDAgMS41MDY3IDAgMS42Njc0MUMgMCAxLjgyODEyIDAuMDgwMzU2NyAyLjAwODkzIDAuMjAwODkyIDIuMTI5NDZMIDguMDk1OTggMTAuMDI0NkwgMC4yMDA4OTIgMTcuOTE5NkMgMC4wODAzNTY3IDE4LjA0MDIgMCAxOC4yMjEgMCAxOC4zODE3QyAwIDE4LjU2MjUgMC4wODAzNTY3IDE4LjcyMzIgMC4yMDA4OTIgMTguODQzOEwgMS4yMDUzNiAxOS44NDgyQyAxLjMyNTg5IDE5Ljk2ODcgMS41MDY3IDIwLjA0OTEgMS42Njc0MSAyMC4wNDkxQyAxLjgyODEzIDIwLjA0OTEgMi4wMDg5MyAxOS45Njg3IDIuMTI5NDYgMTkuODQ4MkwgMTEuNDkxMSAxMC40ODY2QyAxMS42MTE2IDEwLjM2NjEgMTEuNjkyIDEwLjE4NTMgMTEuNjkyIDEwLjAyNDZaIi8+CjwvZGVmcz4KPC9zdmc+Cg=="

/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/nano.b966b1b2.jpg";

/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _header = __webpack_require__(24);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _nano = __webpack_require__(158);
	
	var _nano2 = _interopRequireDefault(_nano);
	
	var _newsPreview = __webpack_require__(230);
	
	var _newsPreview2 = _interopRequireDefault(_newsPreview);
	
	var _research = __webpack_require__(88);
	
	var _research2 = _interopRequireDefault(_research);
	
	var _publication = __webpack_require__(87);
	
	var _publication2 = _interopRequireDefault(_publication);
	
	var _collaborator = __webpack_require__(86);
	
	var _collaborator2 = _interopRequireDefault(_collaborator);
	
	var _seeMore = __webpack_require__(232);
	
	var _seeMore2 = _interopRequireDefault(_seeMore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	
	
	  var researchAreas = [];
	  data.allContentfulResearchAreas.edges.map(function (_ref2) {
	    var node = _ref2.node;
	
	    researchAreas.push(node);
	  });
	
	  var research = researchAreas.map(function (research, index) {
	    return _react2.default.createElement(_research2.default, { key: research.id, title: research.topic, image: research.image.file.url, first: index % 3 === 0, link: '/research/' + research.slug });
	  });
	
	  var latestNews = [];
	  data.allContentfulNews.edges.map(function (_ref3) {
	    var node = _ref3.node;
	
	    latestNews.push(node);
	  });
	
	  var newsPreviews = latestNews.map(function (news, index) {
	    return _react2.default.createElement(_newsPreview2.default, { key: news.id, title: news.title, image: news.image.file.url, description: news.description.description, first: index % 2 === 0, link: '/news/' + news.slug });
	  });
	
	  var sponsors = [];
	
	  // collaborators
	  data.allContentfulCollaborators.edges.map(function (_ref4) {
	    var node = _ref4.node;
	
	    if (!node.sponsor) {
	      sponsors.push(node);
	    }
	  });
	
	  var sponsorImages = sponsors.map(function (sponsor, index) {
	    return _react2.default.createElement(_collaborator2.default, { name: sponsor.name, logo: sponsor.logo.file.url, url: sponsor.link });
	  });
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_header2.default, {
	      image: _nano2.default,
	      title: "NANOTECH LAB | YUSHIN GROUP",
	      subtitle: "Transforming the energy materials landscape from the nanoscale to the macro"
	    }),
	    _react2.default.createElement(
	      'section',
	      { className: "about-blurb" },
	      _react2.default.createElement(
	        'div',
	        { className: "container" },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'p',
	            { className: 'col-xs-12 col-sm-12 col-lg-offset-1 col-lg-10 col-xl-10' },
	            'Our research group focuses on finding nanotechnology-driven solutions\xA0to enable the next generation of lighter, more energy dense, more cost effective energy storage devices by studying their materials structure-property relationships. We have developed nano-scale synthesis strategies to bypass macro-scale limitations of energy and structural materials with applications in clean tech, electric vehicles, wearable electronics, and more.'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: "grey news" },
	      _react2.default.createElement(
	        'div',
	        { className: "container" },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'col-xs-12 col-sm-12 col-lg-offset-1 col-lg-10 col-xl-10' },
	            'News'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          newsPreviews
	        ),
	        _react2.default.createElement(_seeMore2.default, { link: "/news", content: "See all News" })
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: "research" },
	      _react2.default.createElement(
	        'div',
	        { className: "container" },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'col-xs-12 col-sm-12 col-lg-offset-1 col-lg-10 col-xl-10' },
	            'Research Areas'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          research
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: "grey publications" },
	      _react2.default.createElement(
	        'div',
	        { className: "container" },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'col-xs-12 col-sm-12 col-lg-offset-1 col-lg-10 col-xl-10' },
	            'Publications'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          data.allContentfulPublication.edges.map(function (_ref5) {
	            var node = _ref5.node;
	
	            return _react2.default.createElement(_publication2.default, { key: node.id, title: node.title, journal: node.journal, authors: node.authors, year: node.year, abstract: node.description.description, link: node.url });
	          })
	        ),
	        _react2.default.createElement(_seeMore2.default, { link: "/publications", content: "See all Publications" })
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: "collaborators" },
	      _react2.default.createElement(
	        'div',
	        { className: "container" },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'col-xs-12 col-sm-12 col-lg-offset-1 col-lg-11 col-xl-10' },
	            'Collaborators'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: "collaboration col-xs-12 col-sm-12 col-md-12 col-lg-offset-1 col-lg-10 col-xl-10" },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Some of the Institutions we\u2019ve collaborated in the past. For collaboration inquiries, contact Professor Gleb Yushin.'
	            )
	          ),
	          sponsorImages
	        ),
	        _react2.default.createElement(_seeMore2.default, { link: "/collaborators", content: "See all Collaborators" })
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: "grey contact-us" },
	      _react2.default.createElement(
	        'div',
	        { className: "container" },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'col-xs-12 col-sm-12 col-lg-offset-1 col-lg-10 col-xl-10' },
	            'Contact Us'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'p',
	            { className: "col-xs-12 col-sm-12 col-lg-offset-1 col-lg-10 col-xl-10" },
	            'Get in touch! Send an email to Professor Yushin at ',
	            _react2.default.createElement(
	              'a',
	              { href: 'maito:yushin@gatech.edu' },
	              'yushin@gatech.edu'
	            ),
	            '.'
	          )
	        )
	      )
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-7188e6d6ab116fe053ee.js